let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2fUpT")).then(() => parcelRequire('7F6VS'));